import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp } from '@ifeng-fe/callapp';
import styles from './index.css';
import { getFans } from '../../../services/api';

const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

class UserInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pageInfo: PropTypes.object,
    };

    state = {
        fansNumFormat: '0',
        hasWord: false
    }
    async componentDidMount() {
        const { id } = this.props.pageInfo;
        const res = await getFans(id);
        const fansNum = res.data;
        let fansNumFormat = (fansNum && fansNum.toString()) || '0';

        if (fansNumFormat && fansNumFormat.length > 4) {
            fansNumFormat = `${(parseInt(fansNumFormat) / 10000).toFixed(1)}`;

            this.setState({
                fansNumFormat: fansNumFormat || '0',
                hasWord: true
            });
        } else {
            this.setState({
                fansNumFormat: fansNumFormat || '0',
                hasWord: false
            });
        }
    }

    handleFollow = () => {
        const { type, id, url, userId } = this.props.pageInfo;
        const doc_type = type;
        const aid = id;
        const kind = 'inter_fxy03';
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            userId,
            kind,
        });
    };

    render() {
        const userinfo = this.props.content;

        const {
            logo,
            // fansNum,
            weMediaName,
            title_1,
            description,
            location,
            profession,
            birthday,
            sign,
            unsubNum,
            honorImg,
            honorDesc,
            lastArticleAddress,
        } =
            userinfo || {};

        // let fansNumFormat = (fansNum && fansNum.toString()) || '0';
        // let hasWord = false;

        // if (fansNumFormat && fansNumFormat.length > 4) {
        //     fansNumFormat = `${(parseInt(fansNumFormat) / 10000).toFixed(1)}`;
        //     hasWord = true;
        // }

        return (
            <div className={styles.header}>
                <img
                    className={styles.headerImg}
                    src="https://x0.ifengimg.com/ucms/2020_46/4B52E74746F8534778160F19AAAC11A72C516879_w750_h236.png"
                />
                <div className={styles.headerBox}>
                    <div className={styles.headerFaceBox}>
                        <div className={styles.headerFace}>
                            {logo && <img className={styles.headerFaceImg} src={logo} />}
                            {honorImg && <span className={styles.headerVicon} />}
                        </div>
                        <span className={styles.headerFollow} onClick={this.handleFollow} />
                    </div>
                    <div className={styles.headerText}>
                        <div className={styles.headerSource}>
                            <span className={styles.headerName}>{weMediaName}</span>
                            {sign === '大风号' && <span className={styles.headerSign} />}
                        </div>
                        {honorDesc && <h2 className={styles.headerAuth}>{honorDesc}</h2>}
                        {description && <p className={styles.headerBref}>{description}</p>}
                        {!description && !honorDesc && <p className={styles.headerBref}>这家伙很懒，什么也没留下</p>}
                        {lastArticleAddress && (
                            <div className={styles.headerBref}>来自{lastArticleAddress.split(/,|\s|-/)[0]}</div>
                        )}
                        <div className={styles.headerFans}>
                            <span className={styles.headerFansNum}>{this.state.fansNumFormat}</span>
                            {this.state.hasWord && <span className={styles.headerFansUnit}>万</span>}粉丝
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(UserInfo);
